import { render } from "./IntegrationTab.vue?vue&type=template&id=11f6ea84&scoped=true"
import script from "./IntegrationTab.vue?vue&type=script&lang=js"
export * from "./IntegrationTab.vue?vue&type=script&lang=js"

import "./IntegrationTab.vue?vue&type=style&index=0&id=11f6ea84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11f6ea84"]])

export default __exports__